import Vue from 'vue';
import axios from 'axios';
import {getStore, removeStore} from './../utils/utils'
// import qs from 'qs';
const basrURL = 'https://adr.ccpit.org/interface';

axios.defaults.timeout = 60000; // 响应时间
// 配置请求头
axios.defaults.headers = {
  'Content-Type': 'application/json',
  // appName: 'mediate',
  cType: 'h5',
  token: '',
};

axios.defaults.baseURL = basrURL; // 配置接口地址

// POST传参序列化(添加请求拦截器)

axios.interceptors.request.use((config) => {
  // 动态添加token
  let token = getStore('token') || '';
  config.headers.token = token;
  // 在发送请求之前做某件事
  if (config.method === 'post') {
    // config.data = qs.stringify(config.data);
  }
  return config;
}, (error) => {
  console.log('错误的传参', error);
  return Promise.reject(error);
});

// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
  // 对响应数据做些事
  if (res.data.code !== 200) {
    // 对登录超时做拦截
    switch (res.data.code) {
      case '300':
        break;
      case '401':
      case '402':
      case '403':
      case '404':
        Vue.prototype.$toast.clear()
        Vue.prototype.$toast.fail(res.data.message)
        removeStore('loginRole')
        removeStore('menus')
        removeStore('token')
        removeStore('userInfo')
        setTimeout(() => {
          this.$router.push({path: '/user/login'})
        }, 1000)
        break;
      default:
        return Promise.resolve(res);
    }
  }
  return res;
}, (error) => {
  console.log('网络异常');
  return Promise.reject(error);
});

const httpServer = function (opts, data) {
  const httpDefaultOpts = {
    // http默认配置
    method: opts.method || 'post',
    url: opts.url,
  };

  if (opts.method === 'get') {
    httpDefaultOpts.params = data;
  } else {
    httpDefaultOpts.data = data;
  }

  const promise = new Promise(((resolve, reject) => {
    axios(httpDefaultOpts)
      .then((res) => {
        resolve(res);
      })
      .catch((response) => {
      /* errorState(response) */
        reject(response);
      });
  }));
  return promise;
};

export default httpServer;
